import React, { useState } from 'react';
import { Close as CloseIcon } from '@mui/icons-material';
import { Box, Typography, Link, Divider, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import ContactUsForm from '../../pages/business/contactUsForm';
// Import your ContactUsForm component (adjust the import path accordingly) 

const Footer = () => {
  // State to control the Contact Us dialog open/close
  const [openContactDialog, setOpenContactDialog] = useState(false);
  const [contactPrefill, setContactPrefill] = useState(null);

  // Function to open the dialog
  const handleOpenDialog = () => {
    setContactPrefill(null);
    setOpenContactDialog(true);
  };

  const handleOpenDemoDialog = () => {
    setContactPrefill({
      initialReason: "demo",
      initialSubject: "Request a Demo",
      initialMessage:
        "I would like a live demo of Plany365 Care. Please contact me to schedule a walkthrough.",
    });
    setOpenContactDialog(true);
  };

  // Function to close the dialog
  const handleCloseDialog = () => {
    setOpenContactDialog(false);
  };

  return (
    <>
      <Box
        component="footer"
        sx={{
          backgroundColor: "#222",
          color: "#fff",
          width: "100%", // Full width of the viewport
          padding: "1rem 0", // Vertical padding
          position: "relative", // Keeps footer in document flow
        }}
      >
        {/* Top Section with Links */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // Center the links
            alignItems: "center",
            flexWrap: "wrap",
            paddingBottom: "0.5rem",
            gap: "1rem", // Space between the links
          }}
        >
          <Typography variant="h6" sx={{ fontSize: "0.75rem" }}>
            <Link href="/about" color="inherit" underline="none">
              About Us
            </Link>
          </Typography>
          <Typography variant="h6" sx={{ fontSize: "0.75rem" }}>
            <Link href="/privacy" color="inherit" underline="none">
              Privacy Policy
            </Link>
          </Typography>
          <Typography variant="h6" sx={{ fontSize: "0.75rem" }}>
            <Link href="/terms" color="inherit" underline="none">
              Terms & Conditions
            </Link>
          </Typography>
          <Typography variant="h6" sx={{ fontSize: "0.75rem" }}>
            <Link href="/sms-opt-in" color="inherit" underline="none">
              SMS Opt-In Policy
            </Link>
          </Typography>
          <Typography variant="h6" sx={{ fontSize: "0.75rem" }}>
            <Link href="/hipaa-security" color="inherit" underline="none">
              HIPAA & Security
            </Link>
          </Typography>
          <Typography variant="h6" sx={{ fontSize: "0.75rem" }}>
            <Link href="/faq" color="inherit" underline="none">
              FAQ
            </Link>
          </Typography>
          {/* Contact Us Link to open the dialog */}
          <Typography variant="h6" sx={{ fontSize: "0.75rem" }}>
            <Link component="button" onClick={handleOpenDialog} color="inherit" underline="none">
              Contact Us
            </Link>
          </Typography>
          <Typography variant="h6" sx={{ fontSize: "0.75rem" }}>
            <Link component="button" onClick={handleOpenDemoDialog} color="inherit" underline="none">
              Request a Demo
            </Link>
          </Typography>
        </Box>

        {/* Divider */}
        <Divider sx={{ backgroundColor: "#555", marginBottom: "0.5rem" }} />

        {/* Footer Bottom */}
        <Box
          sx={{
            display: "flex", // Use Flexbox for alignment
            justifyContent: "space-between", // Space between text and social icons
            alignItems: "center", // Vertically center the items
            flexWrap: "wrap",
            gap: "0.5rem 1rem",
            padding: "0.25rem 1rem", // Side padding for better spacing
            backgroundColor: "#222", // Matches the footer background
            boxSizing: "border-box", // Ensure padding doesn't affect overall width
          }}
        >
          {/* Footer Text */}
          <Typography
            variant="body2"
            sx={{
              fontSize: "0.65rem",
              textAlign: "left",
              paddingLeft: { xs: 0, sm: "5.25rem" },
              whiteSpace: "nowrap",
              flexShrink: 0,
            }}
          >
            &copy; 2026{" "}
            <Link
              href="https://microlg.com"
              color="inherit"
              underline="hover"
              sx={{ display: "inline-flex", whiteSpace: "nowrap" }}
            >
              Micro Logic
            </Link>
            . All rights reserved.
          </Typography>

          <Typography
            variant="body2"
            sx={{
              fontSize: "0.65rem",
              textAlign: "right",
              whiteSpace: "nowrap",
              flexShrink: 0,
            }}
          >
            Powered by{" "}
            <Link
              href="https://digitalcare4u.com/"
              color="inherit"
              underline="hover"
              sx={{ display: "inline-flex", whiteSpace: "nowrap" }}
            >
              DigitalCare4U
            </Link>
          </Typography>

          {/* TODO Social Media Icons */}
          {/* <Box sx={{ display: "flex", gap: "1rem" }}>
            <Link href="https://www.facebook.com" color="inherit">
              <Facebook />
            </Link>
            <Link href="https://www.twitter.com" color="inherit">
              <Twitter />
            </Link>
            <Link href="https://www.instagram.com" color="inherit">
              <Instagram />
            </Link>
          </Box> */}
        </Box>
      </Box>

      {/* Dialog for Contact Us Form */}
      <Dialog open={openContactDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Contact Us
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <ContactUsForm {...(contactPrefill || {})} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Footer;
